export const VisitEventType = {
  PRICING_PAGE: "Visit PRICING PAGE",
  SLID_DOWNLOAD_PAGE: "Visit SLID DOWNLOAD PAGE",
  DEMO_VIDEO_NOTE_PAGE: "Visit DEMO VIDEO NOTE PAGE",
  VIDEO_RECOMMENDATION_PAGE: "Visit VIDEO RECOMMENDATION PAGE",

  // GROUP Study Challenge
  GROUP_CHALLENGE_PAGE: "Visit GROUP CHALLENGE PAGE",
};
